export const MAN_MU_CONST = {
    END_POINT: "beheerobjecten",

    PLACE_IN_AREA: "PLAATS_IN_GEBIED",
    CHANGE_DISCIPLINE: "WIJZIG_DISCIPLINE",
    REMOVE_FROM_AREA: "VERWIJDER_UIT_GEBIED",
    CREATE_CORRECTIVE_MAINTENANCE: "AANMAKEN_CORRECTIEF_ONDERHOUD",
    ADD_MEASURE: "TOEVOEGEN_MAATREGEL",
    MODIFY_ACTIVE: "WIJZIG_ACTIEF"
}

export const MAN_ME_CONST = {
    END_POINT: "beheeractiviteiten",

    PLACE_IN_GLOBAL_PLANNING: "PLAATS_IN_GLOBALE_PLANNING"
}

export const MAN_PL_CONST = {
    END_POINT: "werkregels",

    PLACE_IN_WORK_PLAN: "PLAATS_IN_WERKPLAN",
    PLACE_IN_DETAIL_PLANNING: "PLAATS_IN_DETAILPLANNING",
    PLACE_IN_WORK_ORDER: "PLAATS_IN_WERKORDER",
    CHANGE_STATUS: "WIJZIG_STATUS",
    PLACE_IN_EXECUTION: "PLAATS_IN_UITVOERING",
    REMOVE_FROM_EXECUTION: "VERWIJDER_UIT_UITVOERING"
}
